/* eslint-disable import/no-duplicates */
/**
 * 媒体渠道图标：与 countries.ts 一致，通过接口返回的 code 解析对应 SVG。
 * 资源目录：@/pages/home/assets/img/mediaChannel（目录内 SVG 均已纳入 mediaChannelMap）
 */
import _default from '@/pages/home/assets/img/mediaChannel/default.svg';
import _admob from '@/pages/home/assets/img/mediaChannel/admob.svg';
import _adSense from '@/pages/home/assets/img/mediaChannel/adSense.svg';
import _adjoe from '@/pages/home/assets/img/mediaChannel/adjoe.svg';
import _adwake from '@/pages/home/assets/img/mediaChannel/adwake.svg';
import _akaNe from '@/pages/home/assets/img/mediaChannel/akaNe.svg';
import _ameba from '@/pages/home/assets/img/mediaChannel/ameba.svg';
import _apple from '@/pages/home/assets/img/mediaChannel/apple.svg';
import _appleSearchAds from '@/pages/home/assets/img/mediaChannel/appleSearchAds.svg';
import _applovin from '@/pages/home/assets/img/mediaChannel/applovin.svg';
import _audienceNetwork from '@/pages/home/assets/img/mediaChannel/audienceNetwork.svg';
import _aura from '@/pages/home/assets/img/mediaChannel/aura.svg';
import _bigoAds from '@/pages/home/assets/img/mediaChannel/bigoAds.svg';
import _chartboost from '@/pages/home/assets/img/mediaChannel/chartboost.svg';
import _daum from '@/pages/home/assets/img/mediaChannel/daum.svg';
import _digitalTurbine from '@/pages/home/assets/img/mediaChannel/digitalTurbine.svg';
import _dtExchange from '@/pages/home/assets/img/mediaChannel/dtExchange.svg';
import _exmox from '@/pages/home/assets/img/mediaChannel/exmox.svg';
import _facebook from '@/pages/home/assets/img/mediaChannel/facebook.svg';
import _google from '@/pages/home/assets/img/mediaChannel/google.svg';
import _gunosy from '@/pages/home/assets/img/mediaChannel/gunosy.svg';
import _honor from '@/pages/home/assets/img/mediaChannel/honor.svg';
import _iMobile from '@/pages/home/assets/img/mediaChannel/iMobile.svg';
import _inMobi from '@/pages/home/assets/img/mediaChannel/inMobi.svg';
import _instagram from '@/pages/home/assets/img/mediaChannel/instagram.svg';
import _ironSource from '@/pages/home/assets/img/mediaChannel/ironSource.svg';
import _kashkick from '@/pages/home/assets/img/mediaChannel/kashkick.svg';
import _kwai from '@/pages/home/assets/img/mediaChannel/kwai.svg';
import _liftoff from '@/pages/home/assets/img/mediaChannel/liftoff.svg';
import _messenger from '@/pages/home/assets/img/mediaChannel/messenger.svg';
import _meta from '@/pages/home/assets/img/mediaChannel/meta.svg';
import _miniclip from '@/pages/home/assets/img/mediaChannel/miniclip.svg';
import _mintegral from '@/pages/home/assets/img/mediaChannel/mintegralMobvista.svg';
import _misc from '@/pages/home/assets/img/mediaChannel/misc.svg';
import _mistplay from '@/pages/home/assets/img/mediaChannel/mistplay.svg';
import _moloco from '@/pages/home/assets/img/mediaChannel/moloco.svg';
import _myAppFree from '@/pages/home/assets/img/mediaChannel/myAppFree.svg';
import _nate from '@/pages/home/assets/img/mediaChannel/nate.svg';
import _naver from '@/pages/home/assets/img/mediaChannel/naver.svg';
import _nend from '@/pages/home/assets/img/mediaChannel/nend.svg';
import _oppo from '@/pages/home/assets/img/mediaChannel/oppo.svg';
import _pangle from '@/pages/home/assets/img/mediaChannel/pangle.svg';
import _pinterest from '@/pages/home/assets/img/mediaChannel/pinterest.svg';
import _playback from '@/pages/home/assets/img/mediaChannel/playback.svg';
import _prime from '@/pages/home/assets/img/mediaChannel/prime.svg';
import _reddit from '@/pages/home/assets/img/mediaChannel/reddit.svg';
import _smartNews from '@/pages/home/assets/img/mediaChannel/smartNews.svg';
import _snapchat from '@/pages/home/assets/img/mediaChannel/snapchat.svg';
import _tapjoy from '@/pages/home/assets/img/mediaChannel/tapjoy.svg';
import _tencent from '@/pages/home/assets/img/mediaChannel/tencent.svg';
import _tiktok from '@/pages/home/assets/img/mediaChannel/tiktok.svg';
import _topBuzz from '@/pages/home/assets/img/mediaChannel/topBuzz.svg';
import _transsion from '@/pages/home/assets/img/mediaChannel/transsion.svg';
import _tyrads from '@/pages/home/assets/img/mediaChannel/tyrads.svg';
import _unityAds from '@/pages/home/assets/img/mediaChannel/unityAds.svg';
import _vibe from '@/pages/home/assets/img/mediaChannel/vibe.svg';
import _vivo from '@/pages/home/assets/img/mediaChannel/vivo.svg';
import _vkontakte from '@/pages/home/assets/img/mediaChannel/vkontakte.svg';
import _x from '@/pages/home/assets/img/mediaChannel/x.svg';
import _xiaomi from '@/pages/home/assets/img/mediaChannel/xiaomi.svg';
import _yahoo from '@/pages/home/assets/img/mediaChannel/yahoo.svg';
import _yahooJapan from '@/pages/home/assets/img/mediaChannel/yahooJapan.svg';
import _yandex from '@/pages/home/assets/img/mediaChannel/yandex.svg';
import _youTube from '@/pages/home/assets/img/mediaChannel/youTube.svg';
import _zucks from '@/pages/home/assets/img/mediaChannel/zucks.svg';

/** 与 countries.ts 中 flagMap 相同：键为 `_` + 渠道标识 */
export const mediaChannelMap = {
  _default,
  _admob,
  _ad_sense: _adSense,
  _adjoe,
  _adwake,
  _aka_ne: _akaNe,
  _ameba,
  _apple,
  _apple_search_ads: _appleSearchAds,
  _applovin,
  _audience_network: _audienceNetwork,
  _aura,
  _bigo_ads: _bigoAds,
  _chartboost,
  _daum,
  _digital_turbine: _digitalTurbine,
  _dt_exchange: _dtExchange,
  _exmox,
  _facebook,
  _google,
  _gunosy,
  _honor,
  _i_mobile: _iMobile,
  _in_mobi: _inMobi,
  _instagram,
  _ironsource: _ironSource,
  _kashkick,
  _kwai,
  _liftoff,
  _messenger,
  _meta,
  _miniclip,
  _mintegral,
  _misc,
  _mistplay,
  _moloco,
  _my_app_free: _myAppFree,
  _nate,
  _naver,
  _nend,
  _oppo,
  _pangle,
  _pinterest,
  _playback,
  _prime,
  _reddit,
  _smart_news: _smartNews,
  _snapchat,
  _tapjoy,
  _tencent,
  _tiktok,
  _top_buzz: _topBuzz,
  _transsion,
  _tyrads,
  _unity_ads: _unityAds,
  _vibe,
  _vivo,
  _vkontakte,
  _x,
  _yahoo,
  _yahoo_japan: _yahooJapan,
  _yandex,
  _you_tube: _youTube,
  _zucks,
  _xiaomi,
};

export type TMediaChannelMapKey = keyof typeof mediaChannelMap;

type TMediaChannelSource = Record<string, string>;

/**
 * 将接口 code（及常见变体）解析为 mediaChannelMap 的键。
 * 先精确匹配，再按子串规则匹配；未命中返回 `_default`。
 */
export const resolveMediaChannelIconKey = (code: string): TMediaChannelMapKey => {
  const n = (code || '').toLowerCase().trim();
  if (!n) {
    return '_default';
  }

  const exact: Partial<Record<string, TMediaChannelMapKey>> = {
    'apple search ads': '_apple_search_ads',
    'google admob': '_admob',
    'google organic search': '_google',
    'liftoff monetize': '_liftoff',
    'fb page': '_facebook',
    'dt exchange': '_dt_exchange',
    'tencent influencer': '_tencent',
    'honor pai': '_honor',
    'pai preload': '_default',
    pai: '_default',
    bigoads: '_bigo_ads',
    gp: '_google',
    x: '_x',
    meta: '_meta',
    vk: '_vkontakte',
    unknown: '_misc',
    others: '_misc',
    not_found: '_misc',
    apple: '_apple',
    miniclip: '_miniclip',
    xiaomi: '_xiaomi',
    transsion: '_transsion',
    aura: '_aura',
    snapchat: '_snapchat',
    facebook: '_facebook',
    tiktok: '_tiktok',
    google: '_google',
    mintegral: '_mintegral',
    adjoe: '_adjoe',
    mistplay: '_mistplay',
    moloco: '_moloco',
    applovin: '_applovin',
    exmox: '_exmox',
    playback: '_playback',
    vibe: '_vibe',
    myappfree: '_my_app_free',
    unity: '_unity_ads',
    liftoff: '_liftoff',
    adwake: '_adwake',
    kashkick: '_kashkick',
    ironsource: '_ironsource',
    tyrads: '_tyrads',
    prime: '_prime',
    vivo: '_vivo',
    digitalturbine: '_digital_turbine',
    oppo: '_oppo',
    honor: '_honor',
    tencent: '_tencent',
  };

  const exactHit = exact[n];
  if (exactHit) {
    return exactHit;
  }

  if (n.includes('apple search')) {
    return '_apple_search_ads';
  }
  if (n.includes('tencent')) {
    return '_tencent';
  }
  if (n.includes('miniclip')) {
    return '_miniclip';
  }
  if (n.includes('honor')) {
    return '_honor';
  }
  if (n.includes('transsion')) {
    return '_transsion';
  }
  if (n.includes('aura')) {
    return '_aura';
  }
  if (n.includes('adjoe')) {
    return '_adjoe';
  }
  if (n.includes('mistplay')) {
    return '_mistplay';
  }
  if (n.includes('exmox')) {
    return '_exmox';
  }
  if (n.includes('playback')) {
    return '_playback';
  }
  if (n.includes('vibe')) {
    return '_vibe';
  }
  if (n.includes('myappfree') || n.includes('my app free')) {
    return '_my_app_free';
  }
  if (n.includes('adwake')) {
    return '_adwake';
  }
  if (n.includes('kashkick')) {
    return '_kashkick';
  }
  if (n.includes('tyrads')) {
    return '_tyrads';
  }
  if (n.includes('prime')) {
    return '_prime';
  }
  if (n.includes('vivo')) {
    return '_vivo';
  }
  if (n.includes('digital turbine') || n.includes('digitalturbine')) {
    return '_digital_turbine';
  }
  if (n.includes('oppo')) {
    return '_oppo';
  }
  if (n.includes('moloco')) {
    return '_moloco';
  }
  if (n.includes('applovin')) {
    return '_applovin';
  }
  if (n.includes('unity')) {
    return '_unity_ads';
  }
  if (n.includes('tiktok')) {
    return '_tiktok';
  }
  if (n === 'pangle') {
    return '_pangle';
  }
  if (n.includes('audience')) {
    return '_audience_network';
  }
  if (n.includes('facebook')) {
    return '_facebook';
  }
  if (n.includes('snapchat')) {
    return '_snapchat';
  }
  if (n.includes('liftoff')) {
    return '_liftoff';
  }
  if (n.includes('ironsource') || n.includes('ironspace')) {
    return '_ironsource';
  }
  if (n.includes('dt exchange')) {
    return '_dt_exchange';
  }
  if (n === 'bigoads' || (n.includes('bigo') && !n.includes('bigabid'))) {
    return '_bigo_ads';
  }
  if (n.includes('chartboost')) {
    return '_chartboost';
  }
  if (n.includes('tapjoy')) {
    return '_tapjoy';
  }
  if (n.includes('reddit')) {
    return '_reddit';
  }
  if (n.includes('mintegral') || n.includes('mobvista')) {
    return '_mintegral';
  }
  if (n.includes('admob')) {
    return '_admob';
  }
  if (n.includes('adsense') || n.includes('ad sense')) {
    return '_ad_sense';
  }
  if (n.includes('youtube')) {
    return '_you_tube';
  }
  if (n.includes('instagram')) {
    return '_instagram';
  }
  if (n.includes('pinterest')) {
    return '_pinterest';
  }
  if (n === 'vk' || n.includes('vkontakte')) {
    return '_vkontakte';
  }
  if (n.includes('twitter') || n.includes('twitter_amplify')) {
    return '_x';
  }
  if (n.includes('yahoo japan') || n.includes('yahoojapan')) {
    return '_yahoo_japan';
  }
  if (n.includes('yahoo')) {
    return '_yahoo';
  }
  if (n.includes('yandex')) {
    return '_yandex';
  }
  if (n.includes('naver')) {
    return '_naver';
  }
  if (n.includes('smartnews')) {
    return '_smart_news';
  }
  if (n.includes('topbuzz') || n.includes('top buzz')) {
    return '_top_buzz';
  }
  if (n.includes('zucks')) {
    return '_zucks';
  }
  if (n.includes('nend')) {
    return '_nend';
  }
  if (n.includes('gunosy')) {
    return '_gunosy';
  }
  if (n.includes('ameba')) {
    return '_ameba';
  }
  if (n.includes('daum')) {
    return '_daum';
  }
  if (n.includes('nate')) {
    return '_nate';
  }
  if (n.includes('inmobi')) {
    return '_in_mobi';
  }
  if (n.includes('imobile') || n.includes('i-mobile')) {
    return '_i_mobile';
  }
  if (n.includes('messenger')) {
    return '_messenger';
  }
  if (n.includes('kwai')) {
    return '_kwai';
  }
  if (n.includes('aka') && n.includes('ne')) {
    return '_aka_ne';
  }
  if (n === 'meta') {
    return '_meta';
  }
  if (n === 'apple' || (n.includes('apple') && !n.includes('search'))) {
    return '_apple';
  }
  if (n.includes('google') || n.includes('adwords')) {
    return '_google';
  }
  if (n.includes('xiaomi')) {
    return '_xiaomi';
  }

  return '_default';
};

/**
 * @param code - 接口返回的媒体渠道 code
 * @param source - 扩展：可传入合并后的 map，未传则使用内置 mediaChannelMap
 */
export const getMediaChannelIcon = (
  code: string,
  source?: TMediaChannelSource,
): string => {
  const map = (source || mediaChannelMap) as TMediaChannelSource;
  const key = resolveMediaChannelIconKey(code);
  return map[key] || map._default;
};
